import { Box, Paper, styled } from '@mui/material';

export const InfoSectionWrapper = styled(Box)(() => ({
	display: 'grid',

	flexDirection: 'column',
	gap: '16px',
}));

export const InfoItemWrapper = styled(Paper)(() => ({
	display: 'flex',
	alignItems: 'center',
	borderRadius: '8px',

	padding: '10px 8px',
	gap: '8px',
}));

export const StyledImage = styled('img')(() => ({
	width: '50%',
}));
